(function () {
  const getInlineSlides = (sliderEl) => {
    if (!sliderEl) return [];
    return Array.from(sliderEl.querySelectorAll('.swiper-slide'));
  };

  const hydrateInlineSlide = (slide) => {
    if (!slide || slide.dataset.inlineHydrated === 'true') return;

    const template = slide.querySelector('.product-inline-media-template');
    if (!template) return;

    slide.appendChild(template.content.cloneNode(true));
    slide.dataset.inlineHydrated = 'true';
  };

  const hydrateInlineAround = (sliderEl, activeIndex) => {
    const slides = getInlineSlides(sliderEl);
    if (!slides.length) return;

    const indexes = new Set([activeIndex - 1, activeIndex, activeIndex + 1]);
    indexes.forEach((index) => {
      if (index >= 0 && index < slides.length) {
        hydrateInlineSlide(slides[index]);
      }
    });
  };

  const prepareInlineSlider = (sliderEl, initialIndex) => {
    if (!sliderEl) return;
    hydrateInlineAround(sliderEl, initialIndex || 0);
  };

  window.ProductInlineMediaLazy = {
    hydrateAround: hydrateInlineAround,
    prepareForSlider: prepareInlineSlider,
  };

  const slideAccordion = (description, open) => {
    if (!description) return;

    description.getAnimations().forEach((animation) => animation.cancel());
    description.style.overflow = 'hidden';

    const from = open ? 0 : description.getBoundingClientRect().height;
    if (open) {
      description.style.display = 'block';
      description.style.height = '0px';
    }

    const to = open ? description.scrollHeight : 0;
    const animation = description.animate(
      [{ height: from + 'px' }, { height: to + 'px' }],
      { duration: 300, easing: 'ease-in-out' }
    );

    animation.onfinish = () => {
      description.style.overflow = '';
      description.style.height = '';
      description.style.display = open ? 'block' : 'none';
    };
  };

  const initProductAccordion = () => {
    document.querySelectorAll('.product__about-list .about__accordion-toggle').forEach((toggle) => {
      if (toggle.dataset.accordionBound === 'true') return;
      toggle.dataset.accordionBound = 'true';

      toggle.addEventListener('click', () => {
        const description = toggle.nextElementSibling;
        const currentDesc = description && description.classList.contains('about__accordion-description')
          ? description
          : null;
        const group = toggle.closest('.product__about-list');
        const isActive = toggle.classList.contains('active');

        if (group) {
          group.querySelectorAll('.about__accordion-toggle.active').forEach((other) => {
            if (other === toggle) return;
            other.classList.remove('active');
            const otherDesc = other.nextElementSibling;
            if (otherDesc && otherDesc.classList.contains('about__accordion-description')) {
              slideAccordion(otherDesc, false);
            }
          });
        }

        if (isActive) {
          toggle.classList.remove('active');
          slideAccordion(currentDesc, false);
        } else {
          toggle.classList.add('active');
          slideAccordion(currentDesc, true);
        }
      });
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper || imagesWrapper.dataset.zoomInit === 'true') return;

    imagesWrapper.dataset.zoomInit = 'true';
    imagesWrapper.addEventListener('click', (event) => {
      if (event.target.closest('.js-image-zoom')) {
        imagesWrapper.classList.toggle('zoom');
      }
    });
  };

  /** variant_picker_v3 的 swiper 初始化 */
  const initVariantSliderV3 = () => {
    const sliders = document.querySelectorAll('.js-product-variant-slider-v3');
    if (!sliders.length || typeof Swiper === 'undefined') return;

    sliders.forEach((slider) => {
      const swiperEl = slider.querySelector('.js-product-variant-group-v3');
      const nextButton = slider.querySelector('.product-form__controls-nav--next');

      if (!swiperEl || !nextButton) return;
      slider.classList.remove('is-swiper-ready');
      if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

      const scrollSelectedIntoView = (swiperInstance) => {
        const checkedInput = swiperEl.querySelector('input:checked');
        if (!checkedInput) return;

        const slide = checkedInput.closest('.swiper-slide');
        if (!slide) return;

        const slideIndex = Array.from(swiperEl.querySelectorAll('.swiper-slide')).indexOf(slide);
        if (slideIndex >= 0) swiperInstance.slideTo(slideIndex);
      };

      const swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        freeMode: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: nextButton,
        },
        on: {
          afterInit: function (swiper) {
            scrollSelectedIntoView(swiper);
            requestAnimationFrame(() => {
              slider.classList.add('is-swiper-ready');
            });
          },
        },
        breakpoints: {
          750: {
            spaceBetween: 10,
          },
        },
      });

      swiperEl.addEventListener('change', () => {
        setTimeout(() => {
          swiperInstance.update();
          scrollSelectedIntoView(swiperInstance);
        }, 0);
      });
    });
  };

  const initFreeGiftSwipers = (root = document) => {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('.product__free-gift-swiper').forEach((giftRoot) => {
      const swiperEl = giftRoot.querySelector('.product__free-gift-swiper-inner');
      const nextEl = giftRoot.querySelector('.product__free-gift-nav--next');
      if (!swiperEl || !nextEl) return;

      if (swiperEl.dataset.swiperInit === 'true' && swiperEl.swiper) return;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      const container = swiperEl.closest('.swiper-container');
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      if (!slides.length) return;

      const isAutoplay = container && container.dataset.autoplay === 'true';
      const delay = container ? parseInt(container.dataset.delay, 10) * 1000 || 5000 : 5000;

      swiperEl.dataset.swiperInit = 'true';

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slides.length > 1,
        observer: true,
        observeParents: true,
        autoplay: isAutoplay
          ? {
              delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        navigation: {
          nextEl,
        },
      });
    });
  };

  document.addEventListener('shopify:section:load', (event) => {
    initProductAccordion();
    initZoomImage();
    initVariantSliderV3();
    initFreeGiftSwipers(event.target);
  });

  initZoomImage();
  initVariantSliderV3();
  initProductAccordion();

  const bootFreeGiftSwipers = () => initFreeGiftSwipers();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFreeGiftSwipers);
  } else {
    bootFreeGiftSwipers();
  }
})();
